import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { addRouteNamespace } from '@Utils/actions';
import { resetConfigurationsStore } from '@Actions';

type SensorsRedirectsReturn = [
	() => void,
	() => void,
	() => void,
	(id: string) => void,
];

export const useSensorsRedirects = (): SensorsRedirectsReturn => {
	const history = useHistory();
	const dispatch = useDispatch();

	return useMemo(() => {
		const redirectToHandler = (route: string) => (): void => {
			history.push(addRouteNamespace(route));
		};

		const redirectToCreateSensorPage = redirectToHandler(
			'create-sensor-configuration',
		);
		const redirectToBulkSensorCreationPage =
			redirectToHandler('create-bulk-sensor');
		const redirectToUploadSensorDataPage =
			redirectToHandler('upload-sensor-data');
		const redirectToEditSensorDataPageRedirector = (
			id: string,
		): (() => void) => redirectToHandler(`sensors/${id}/edit`);

		const cleanStoreAndRedirectToCreateSensorPage = () => {
			redirectToCreateSensorPage();
			dispatch(resetConfigurationsStore());
		};
		const cleanStoreAndRedirectToSensorEditPage = (id: string): void => {
			redirectToEditSensorDataPageRedirector(id)();
			dispatch(resetConfigurationsStore());
		};

		return [
			cleanStoreAndRedirectToCreateSensorPage,
			redirectToBulkSensorCreationPage,
			redirectToUploadSensorDataPage,
			cleanStoreAndRedirectToSensorEditPage,
		];
	}, []);
};
